import { processSteps } from "../../../data/homepage";
import Reveal from "../../ui/Reveal";
import Section from "../../ui/Section";

const stepImages = [
  "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1529078155058-5d716f45d604?auto=format&fit=crop&w=900&q=80"
];

function ProcessPreview() {
  return (
    <Section tone="white" className="border-t border-brand-line/45">
      <div className="text-center">
        <h2 className="text-3xl font-semibold tracking-tight text-brand-navy sm:text-5xl">
          The Counselling Process
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base text-brand-charcoal/72">
          Each stage has a clear purpose so students and parents always know what happens next.
        </p>
        <div className="mx-auto mt-7 h-px w-20 bg-brand-gold-strong/65" />
      </div>

      <div className="relative mx-auto mt-14 max-w-5xl space-y-14">
        <div className="absolute bottom-0 left-1/2 top-0 hidden w-px -translate-x-1/2 bg-brand-line/55 md:block" />

        {processSteps.map((item, index) => {
          const isEven = index % 2 === 0;

          return (
            <Reveal key={item.step} delay={index * 0.08}>
              <article className="relative grid gap-8 md:grid-cols-2 md:items-center">
                <div className={`${isEven ? "md:text-right" : "md:order-2 md:text-left"}`}>
                  <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-gold-strong">
                    Phase {item.step}
                  </p>
                  <h3 className="mt-3 text-2xl font-semibold text-brand-navy">{item.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-brand-charcoal/74">{item.description}</p>
                </div>

                <div className={`${isEven ? "" : "md:order-1"}`}>
                  <div className="overflow-hidden border border-brand-line/45 bg-[#f3f3f3]">
                    <img
                      src={stepImages[index]}
                      alt={item.title}
                      className="h-52 w-full object-cover grayscale transition-all duration-500 hover:grayscale-0"
                      loading="lazy"
                    />
                  </div>
                </div>

                <span className="absolute left-1/2 top-1/2 hidden h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-brand-navy md:block" />
              </article>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
}

export default ProcessPreview;
